import z from 'zod';

export const checkoutSchema = z
  .object({
    deliveryMethod: z.enum(['post_machine', 'door_to_door']).or(
      z.string().refine(() => false, {
        message: 'Please select a delivery method',
      }),
    ),
    parcelTerminalId: z.string().optional(),
    address_id: z.number().optional(),
    promo_code: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.deliveryMethod === 'post_machine') {
        return !!data.parcelTerminalId;
      }
      return true;
    },
    {
      message: 'Please select a parcel terminal',
      path: ['parcelTerminalId'],
    },
  )
  .refine(
    (data) => {
      if (data.deliveryMethod === 'door_to_door') {
        return !!data.address_id && data.address_id > 0;
      }
      return true;
    },
    {
      message: 'Please select an address',
      path: ['address_id'],
    },
  );

export const checkoutSuccessSearchSchema = z.object({
  session_id: z.string().optional(),
});

export const checkoutFailSearchSchema = z.object({
  session_id: z.string().optional(),
});
